import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './index.css';
import ReactCodeInput from 'react-code-input';
import { Spin } from 'antd';
import { LoadingOutlined, EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import api_config from 'lib/api/common';
import UseAPI from 'lib/api/UseAPI';
import validator from 'validator';
import Logo from '../../assets/img/logo.png';
import LPPromoItem1 from './LPPromoItem1';
import { getReferralCodeFromCookie } from './CookieUtil';
import { FormContainer, FormInputField, SignupButton, TermsText, PasswordInputContainer, PasswordToggleIcon } from './AuthStyles';
import { GoogleLogin } from '@react-oauth/google';
import AuthContainer from './AuthContainer';
import useCustomNotification from '../../hooks/useCustomNotification';
import NotificationProvider from '../../components/CustomNotification/NotificationProvider';
import { trackFirstRunEvent } from '../../lib/utils/firstRunEvents';

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);
const SignUp = () => {
  const { notifications, removeNotification, api } = useCustomNotification();
  const openNotificationWithIcon = (type, message, desc) => {
    api[type](message, desc);
  };

  const location = useLocation();
  const navigate = useNavigate();

  const [firstname, setfirstname] = useState('');
  const [lastname, setlastname] = useState('');
  const [pwd, setPwd] = useState('');
  const [matchPwd, setMatchPwd] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showMatchPassword, setShowMatchPassword] = useState(false);
  const [isEnableSignUp, setEnableSignUp] = useState(false);
  const [isVerifyLoading, setVerifyLoading] = useState(false);
  const [isSubmitLoading, setSubmitLoading] = useState(false);
  const [isUserLoading, setUserloading] = useState(false);

  const [user, setUser] = useState('');
  const [isDisableduser, setDisableUser] = useState(false);
  const [isVerifyStatus, setVerifyCodeStatus] = useState(false);

  const [code, setCode] = useState('');
  const [isEnablecode, setEnableCode] = useState(false);
  const [isEnableSignUpAPI, setEnableAPISignUp] = useState(false);

  const handleChange = (e) => {
    setUser(e.target.value);
  };
  const handleCode = (value) => {
    setCode(value);
  };

  let oldTitle = document.title;
  useEffect(() => {
    document.title = "Sign up | Sayify";
    return () => {
      document.title = oldTitle;
    };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const nextUrl = params.get('next');

    if (nextUrl) {
      sessionStorage.setItem('nextUrl', nextUrl);
    }
    return () => { };
  }, []);

  const handleAPISubmit = async () => {
    setUserloading(true);
    let payload;
    if (validator.isEmail(user)) {
      payload = {
        email: user,
        signup: true,
      };
    } else {
      setUserloading(false);
      openNotificationWithIcon('error', 'Enter a valid email', 'A valid email address is required');
      return;
    }
    let url = api_config.BASE_BACKEND_ENDPOINT + 'api/send-verification-code/';
    api_config.ABORT_CONTROLLER = new AbortController();
    const signal = api_config.ABORT_CONTROLLER.signal;

    try {
      UseAPI(signal, url, 'POST', payload)
        .then(function (response) {
          if (response.code === 403) {
            openNotificationWithIcon(
              'error',
              'Failed to send verification code',
              response.message || "Signup from this domain has been temporarily restricted due to unusual activity. Please contact support@sayify.pro if you believe this is an error.",
            );
          }
          else if (response.code === 410) {
            openNotificationWithIcon(
              'error',
              'Failed to send verification code',
              'The provided email address already exist in our system. Please login instead. If you forgot your password, please reset. ',
            );
          }
          else if (response.code === 500) {
            openNotificationWithIcon(
              'error',
              'Failed to send verification code',
              'The verification code was not sent due to some server error. Please retry again later.',
            );
          }
          else if (response.code === 200) {
            openNotificationWithIcon(
              'success',
              'Verification code sent',
              'We have sent a verification code to your email. Please check your inbox ',
            );

            setVerifyCodeStatus(true);
            setDisableUser(true);
            setEnableCode(true);
            setSubmitLoading(false);
            setVerifyLoading(true);
          }

          setUserloading(false);
        })
        .catch(function (err) {
          setUserloading(false);
        });
    } catch (err) {
      openNotificationWithIcon(
        'error',
        'Failed to send verification code',
        'The verification code was not sent due to some server error. Please retry again later.',
      );
    }
  };

  const handleVerifyCode = async () => {
    setUserloading(true);
    let payload = {
      email: user,
      code: code,
    };
    let url = api_config.BASE_BACKEND_ENDPOINT + 'api/verify-code/';
    api_config.ABORT_CONTROLLER = new AbortController();
    const signal = api_config.ABORT_CONTROLLER.signal;

    try {
      UseAPI(signal, url, 'POST', payload)
        .then(function (response) {
          setUserloading(false);
          if (response.code === 400) {
            openNotificationWithIcon(
              'error',
              'Email verification failed',
              'The security code is invalid',
            );
          }
          if (response.code === 200) {
            setVerifyLoading(false);
            setDisableUser(true);
            setEnableCode(false);
            setEnableSignUp(true);
            setSubmitLoading(true);
            setEnableAPISignUp(true);
            openNotificationWithIcon(
              'success',
              'Verification successful',
              'Your email is now verified successfully ',
            );
          }
        })
        .catch(function (err) {
          openNotificationWithIcon(
            'error',
            'Email verification failed',
            'We could not verify your email. Please try again or contact support@sayify.pro ',
          );

          setUserloading(false);
        });
    } catch (err) {
      setUserloading(false);

      openNotificationWithIcon(
        'error',
        'Email verification failed',
        'We could not verify your email. Please try again or contact support@sayify.pro ',
      );
    }
  };

  const handleSignUp = async () => {
    setUserloading(true);
    let payload = {
      email: user,
      first_name: firstname,
      last_name: lastname,
      password: pwd,
      password2: matchPwd,
      referral_code: getReferralCodeFromCookie()
    };
    let url = api_config.BASE_BACKEND_ENDPOINT + 'api/signup/';
    api_config.ABORT_CONTROLLER = new AbortController();
    const signal = api_config.ABORT_CONTROLLER.signal;

    try {
      UseAPI(signal, url, 'POST', payload)
        .then(function (response) {
          setUserloading(false);
          if (response.success === true) {
            import('react-ga4').then((ReactGA) => {
              // Enhanced conversions: gtag hashes the email before sending.
              ReactGA.default.gtag('set', 'user_data', { email: user });
              ReactGA.default.event({
                category: "User",
                action: "Signup",
                label: "Email"
              });
            });

            trackFirstRunEvent('signup_completed', { method: 'email' });
            openNotificationWithIcon(
              'success',
              'Account created successfully',
              'Sign in and we will set up your first form.',
            );
            navigate('/login');
          }
          if (response.code === 400) {
            openNotificationWithIcon(
              'error',
              'Signup failed',
              'Your account creation was not successful. Please try again or contact support@sayify.pro ',
            );
          }
        })
        .catch(function (err) {
          openNotificationWithIcon(
            'error',
            'Signup failed',
            'Your account creation was not successful. Please try again or contact support@sayify.pro ',
          );
          setUserloading(false);
        });
    } catch (err) {
      setUserloading(false);

      openNotificationWithIcon(
        'error',
        'Signup failed',
        'Your account creation was not successful. Please try again or contact support@sayify.pro ',
      );
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (isVerifyStatus) {
      if (isEnableSignUpAPI) {
        handleSignUp();
      } else {
        handleVerifyCode();
      }
    } else {
      handleAPISubmit();
    }
  };

  return (
    <>
      <NotificationProvider notifications={notifications} onRemove={removeNotification} />
      <AuthContainer
        leftContent={
          <LPPromoItem1
            heading={<>Your first onboarding form in <span>under 3 minutes</span></>}
            subheading="Pick a template, record a test answer, and watch Sayify turn it into a case. Free plan, no card."
          />
        }
        logo={<img style={{ width: '140px' }} src={Logo} alt="Sayify.pro" />}
        title="Create your account"
        subtitle="25 free responses a month. No card required."
        footerLinks={
          <>
            <p>
              Already have an account with us?
              <Link to="/login">Login</Link>
            </p>
          </>
        }
      >
        <div className="google-login-container">
          <GoogleLogin
            theme='outline'
            size='large'
            text='signup_with'
            shape='pill'
            logo_alignment='left'
            width='360px'
            onSuccess={credentialResponse => {
              let url = api_config.BASE_BACKEND_ENDPOINT + 'api/social-auth/';
              let apiConfigController = new AbortController();
              const signal = apiConfigController.signal;
              let accessToken = credentialResponse.credential;
              let payload = {
                access_token: accessToken,
                referral_code: getReferralCodeFromCookie()
              }
              UseAPI(signal, url, 'POST', payload)
                .then(function (data) {
                  if (data.success) {
                    const token = data.token;
                    localStorage.clear();
                    localStorage.setItem('loggedIn', true);
                    localStorage.setItem('user-token', token);

                    import('react-ga4').then((ReactGA) => {
                      // social-auth logs existing users in too; only a freshly
                      // created account counts as a Signup conversion.
                      if (data.is_new_user) {
                        if (data.user_info && data.user_info.email) {
                          // Enhanced conversions: gtag hashes the email before sending.
                          ReactGA.default.gtag('set', 'user_data', { email: data.user_info.email });
                        }
                        ReactGA.default.event({
                          category: "User",
                          action: "Signup",
                          label: "Google"
                        });
                      }
                      if (data.user_info && data.user_info.id) {
                        ReactGA.default.set({ userId: data.user_info.id });
                      }
                    });

                    if (data.is_new_user) {
                      trackFirstRunEvent('signup_completed', { method: 'google' });
                    }
                    openNotificationWithIcon('success', 'Signup Success', 'You are now signed in.');
                    const nextUrl = sessionStorage.getItem('nextUrl');
                    if (nextUrl) {
                      sessionStorage.removeItem('nextUrl');
                      navigate(nextUrl);
                    }
                    else {
                      // First-run flow, not the dashboard.
                      navigate('/start');
                    }
                  } else {
                    openNotificationWithIcon(
                      'error',
                      'Signup Failed',
                      data.message || 'We couldn\'t sign you up. Please try again later.',
                    );
                  }
                })
                .catch(function (err) {
                  openNotificationWithIcon(
                    'error',
                    'Signup Failed',
                    'We couldn\'t sign you up. Please try again later.',
                  );
                });
            }}
            onError={() => {
              openNotificationWithIcon('error', 'Signup Failed', 'Could not sign up with Google. Please retry again later.');
            }}
          />
        </div>

        <div style={{ display: 'flex', alignItems: 'center', margin: '1rem 0' }}>
          <div style={{ flex: 1, height: '1px', background: '#DDD4CC' }}></div>
          <span style={{ padding: '0 1rem', color: '#6A625B', fontSize: '0.875rem', fontWeight: '500' }}>OR</span>
          <div style={{ flex: 1, height: '1px', background: '#DDD4CC' }}></div>
        </div>

        <FormContainer className="auth-form" onSubmit={handleSubmit}>
          <FormInputField
            type="text"
            id="username"
            disabled={isDisableduser}
            placeholder="Enter your email"
            autoComplete="off"
            onChange={handleChange}
            value={user}
            required
          />
          {isEnableSignUp && (
            <div>
              <FormInputField
                type="text"
                id="firstname"
                placeholder="Enter your first name"
                autoComplete="off"
                onChange={(e) => setfirstname(e.target.value)}
                value={firstname}
                required
              />
              <FormInputField
                type="text"
                id="lastname"
                placeholder="Enter your last name"
                autoComplete="off"
                onChange={(e) => setlastname(e.target.value)}
                value={lastname}
                required
              />
              <PasswordInputContainer>
                <FormInputField
                  type={showPassword ? "text" : "password"}
                  id="password"
                  placeholder="Enter your password"
                  onChange={(e) => setPwd(e.target.value)}
                  value={pwd}
                  required
                  disabled={isUserLoading}
                  aria-label="Password"
                />
                <PasswordToggleIcon
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                </PasswordToggleIcon>
              </PasswordInputContainer>
              <PasswordInputContainer>
                <FormInputField
                  type={showMatchPassword ? "text" : "password"}
                  id="confirm_pwd"
                  placeholder="Enter your password again"
                  onChange={(e) => setMatchPwd(e.target.value)}
                  value={matchPwd}
                  required
                  disabled={isUserLoading}
                  aria-label="Confirm Password"
                />
                <PasswordToggleIcon
                  type="button"
                  onClick={() => setShowMatchPassword(!showMatchPassword)}
                  aria-label={showMatchPassword ? "Hide password" : "Show password"}
                >
                  {showMatchPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                </PasswordToggleIcon>
              </PasswordInputContainer>
            </div>
          )}
          {isEnablecode && (
            <div style={{ marginBottom: '1rem', textAlign: 'center' }}>
              <ReactCodeInput
                type="text"
                className="auth-code"
                inputStyle={{
                  marginRight: '12px',
                  height: '54px',
                  padding: '6px 10px',
                  outline: 'none',
                  fontSize: '24px',
                  border: '2px solid #DDD4CC',
                  borderRadius: '12px',
                  background: '#FCFAF7',
                  color: '#201C18'
                }}
                onChange={handleCode}
                fields={6}
              />
            </div>
          )}

          <TermsText style={{ marginTop: '7px' }}>By signing up, I agree to the <a style={{ textDecoration: 'underline' }} target='_blank' href="https://sayify.pro/privacy/">privacy policy</a> and <a style={{ textDecoration: 'underline' }} target='_blank' href="https://sayify.pro/terms/">terms and conditions</a>.</TermsText>

          <SignupButton>
            {isVerifyLoading ? (
              <div>
                {isUserLoading && (
                  <Spin
                    indicator={antIcon}
                    style={{
                      color: 'white',
                      marginRight: '10px',
                      marginTop: '3px',
                    }}
                  />
                )}
                <span>Verify</span>
              </div>
            ) : isSubmitLoading ? (
              <div>
                {isUserLoading && (
                  <Spin
                    indicator={antIcon}
                    style={{
                      color: 'white',
                      marginRight: '10px',
                      marginTop: '3px',
                    }}
                  />
                )}
                <span>Submit</span>
              </div>
            ) : (
              <div>
                {isUserLoading && (
                  <Spin
                    indicator={antIcon}
                    style={{
                      color: 'white',
                      marginRight: '10px',
                      marginTop: '3px',
                    }}
                  />
                )}
                <span>Continue</span>
              </div>
            )}
          </SignupButton>
        </FormContainer>
      </AuthContainer>
    </>
  );
};

export default SignUp;
